<template>
  <div class="editorTrustMateSection">
    <div class="container">
      <div class="editorTrustMateSection__widget">
        <div id="6c317413-d281-43c8-b92a-8c631af6bbbb"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditorTrustMateSection',
  components: {},
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    widgetId() {
      return '6c317413-d281-43c8-b92a-8c631af6bbbb';
    },
    scriptId() {
      return `trustmate-script-${1000753}-${this.product}`;
    },
  },
  mounted() {
    this.$helper.loadScript(
      `https://trustmate.io/widget/api/6c317413-d281-43c8-b92a-8c631af6bbbb/script`,
      this.scriptId,
    );
  },
  destroyed() {
    this.$helper.removeScriptById(this.scriptId);
  },
};
</script>
<style lang="scss">
.tm-ferret2 {
  margin: 0 !important;
}

.tm-ferret2 .tm-carousel__grade-card {
  margin: 0 2em 0 0 !important;
  min-width: 25em !important;
}

.tm-ferret2 .tm-carousel__progress-track {
  width: 100% !important;
}
.tm-ferret2 .tm-carousel__omnibus-button-wrapper {
  top: -3em !important;

  @include rwd('tablet') {
    top: -1.5em !important;
  }
}

@media (max-width: 767px) {
  .tm-ferret2 .tm-carousel__card-wrapper {
    width: calc(50vw - 5.4em) !important;
  }
}

@media (max-width: 500px) {
  .tm-ferret2 .tm-carousel__card-wrapper {
    width: calc(80vw - 5.4em) !important;
  }
}

@media (min-width: 0px) {
  .tm-ferret2 .tm-carousel__card--noImage {
    height: 32em !important;
  }
}
</style>
<style lang="scss" scoped>
.editorTrustMateSection {
  margin: 3rem auto 4rem;

  @include rwd('tablet') {
    margin: 1rem auto 2rem;
  }

  &__widget {
    height: 430px;

    @include rwd('tablet') {
      height: 521px;
    }
  }
}
</style>
